export function formatNumber(
  numStr: string | number | null | undefined,
  padLength = 0,
): string {
  if (numStr === null || numStr === undefined || numStr === "") {
    return "Price on request";
  }

  // Convert to number
  const num = typeof numStr === "string" ? Number(numStr) : numStr;

  // Handle invalid numbers (NaN, Infinity, etc.)
  if (!Number.isFinite(num)) {
    return "Price on request";
  }

  // Format valid numbers
  const formattedNum = num.toFixed(0);
  return formattedNum.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// Single admin formatter: locale grouping + K/M compact for large values.
// Visual-only; numeric semantics unchanged.
export function formatCompactNumber(
  value: number | null | undefined,
): string {
  if (value === null || value === undefined || !Number.isFinite(value)) {
    return "—";
  }
  const abs = Math.abs(value);
  if (abs >= 1_000_000) {
    const m = value / 1_000_000;
    return `${m >= 100 ? m.toFixed(0) : m.toFixed(1).replace(/\.0$/, "")}M`;
  }
  if (abs >= 10_000) {
    const k = value / 1_000;
    return `${k >= 100 ? k.toFixed(0) : k.toFixed(1).replace(/\.0$/, "")}K`;
  }
  return formatNumber(value);
}
